(ns frontend.ux-overhaul.kanban.v2
  (:require
   [clojure.string :as string]
   [frontend.utils :as fu]
   [reagent.core :as r]
   [oops.core :as oops]))

(defn adapt
  [component]
  (try
    (r/adapt-react-class component)
    (catch js/Object e
      (prn (.-message e)))))

;; Replaced dnd elements with divs to make the code compile,
;; so we can leave this implementation as reference,
;; even though beautiful-dnd was removed
(def drag-drop-context :div)
(def droppable :div)
(def draggable :div)

(defn recompute-row-heights!
  [cell-measurer-props {:keys [local-state column-index]}]
  (let [list-ref (get-in @local-state [:kanban :list-ref column-index])
        measure-fn (aget cell-measurer-props "measure")
        update-fn (aget list-ref "recomputeRowHeights")]
    (when (and measure-fn update-fn)
      (js/setTimeout
       (fn []
         (.call measure-fn cell-measurer-props)
         (js/setTimeout
          (fn [] (.call update-fn list-ref))
          20))
       20))))

(defn re-render-kanban-board
  [local-state]
  (when-let [board-ref (get-in @local-state [:kanban :board-ref])]
    (when-let [recompute-fn (aget board-ref "recomputeGridSize")]
      (.call recompute-fn board-ref)))
  (when-let [overlay-ref (get-in @local-state [:overlay :board-ref])]
    (when-let [recompute-fn (aget overlay-ref "recomputeGridSize")]
      (.call recompute-fn overlay-ref))))


(defn kanban-card
  [{:keys [data recompute-row-heights!]} card-settings]
  (let [card-size (-> card-settings
                      :look-and-feel
                      :card-size)
        card-height (condp = card-size
                      :compact "74px"
                      :medium "250px"
                      :large "450px"
                      "250px")

        country (:country data)

        target (:target data)

        show-footer? (some->> card-settings
                              :card-footer
                              :show-footer?)

        color-coding (-> card-settings
                         :color-coding)
        default-color "#fafafa"
        color (if (-> color-coding
                      :use-color-coding?)
                (let [attribute (-> color-coding
                                    :attribute)
                      value (get data attribute)
                      color (-> color-coding
                                :matches
                                (get value)
                                (or default-color))]
                  color)
                default-color)]
    [:div.d-flex.flex-column.justify-content-between
     {:style {:height        card-height
              :min-width     "280px"
              :max-width     "280px"
              :background    "white"
              :box-shadow    "1px 1px 3px 1px #d4d4d4"
              :border-radius "5px"}}
     [:div.p-2.d-flex.justify-content-between {:style {:background color}}
      [:h3 {:style {:font-size "19px" :font-weight "300"}} (:header data)]
      [:input {:type "checkbox"}]]

     (when (or (= card-size :medium) (= card-size :large))
       [:div.d-flex.flex-column.p-2
        {:style {:overflow   "hidden"
                 :overflow-y "scroll"
                 :flex-grow  "2"
                 :background "white"}
         :class "hide-scrollbars"}
        [:div.mb-3
         [:p {:style {:color "#7a7a7a"}} "Target"]
         [:p {:style {:font-size "18px"}} target]]

        [:div.mb-3
         [:p {:style {:color "#7a7a7a"}} "Country"]
         [:p {:style {:font-size "18px"}} country]]])
     (when show-footer?
       [:div.p-2.d-flex.justify-content-between {:style {:background color}}
        [:i.fal.fa-archive]
        [:i.fal.fa-desktop]
        [:i.fal.fa-plane]
        [:div
         {:style    {:cursor "pointer"}
          :on-click (fn []

                      (recompute-row-heights!))}
         [:i.fal.fa-arrow-down]]
        [:p {:style {:font-size "18px"}}]])]))

(defn row-renderer
  [props js-args]
  (let [{:keys [card-renderer items cache outer-column-index local-state]} props
        {:keys [is-visible columnIndex key parent row-index style index]} (js->clj js-args :keywordize-keys true)
        item (nth items index)]
    (r/as-element
     [draggable
      {:key          (-> item
                         :db/id
                         str)
       :draggable-id (-> item
                         :db/id
                         str)
       :style        style
       :index        index}
      (fn
        [provided snapshot]
        (r/as-element
         [:div
          (merge
           {:style style}
           (js->clj (.-draggableProps provided))
           (js->clj (.-dragHandleProps provided))
           {:ref (.-innerRef provided)})
          (r/as-element
           [:> js/ReactVirtualized.CellMeasurer
            (merge
             {:cache        cache
              :column-index 0
              :key          key
              :parent       parent
              :row-index    index})
            (fn [props]
              (r/as-element
               [:div
                (card-renderer {:data         item
                                :cache        cache
                                :column-index outer-column-index
                                :recompute-row-heights!
                                (partial recompute-row-heights!
                                         props
                                         {:local-state  local-state
                                          :column-index outer-column-index})})]))])]))])))

(defn calculate-drop-position
  [local-state]
  (let [kanban-id (get-in @local-state [:kanban :id])
        classname (str "kanban-" kanban-id "-drop-target")
        drop-targets (.getElementsByClassName js/document classname)
        drag-clone (.getElementById js/document "drag-clone")]
    (when (and drop-targets drag-clone)
      (let [rect (.getBoundingClientRect drag-clone)

            set-target-col (fn [target-column-index]
                             (swap! local-state assoc-in [:overlay :drop-target-column] target-column-index)

                             (when-let [overlay-board-ref (get-in @local-state [:overlay :board-ref])]
                               (js/setTimeout (fn []
                                                (oops/ocall+ overlay-board-ref "recomputeGridSize")) 100)))

            clone-center-x (/ (+ (.-right rect) (.-left rect)) 2)
            clone-center-y (/ (+ (.-top rect) (.-bottom rect)) 2)

            drop-target (->> drop-targets
                             (filter (fn [dt]
                                       (let [rect (.getBoundingClientRect dt)
                                             left (.-left rect)
                                             right (.-right rect)
                                             top (.-top rect)
                                             bottom (.-bottom rect)]
                                         (and (< left clone-center-x right)
                                              (< top clone-center-y bottom)))))
                             (first))]
        (if-not drop-target
          (set-target-col nil)
          (let [drop-target-classes (.-className drop-target)

                ; Todo make this better
                target-index (some-> drop-target-classes
                                     (string/split #" ")
                                     (second)
                                     (string/split #"-")
                                     (nth 2)
                                     (int))
                previous-target (get-in @local-state [:overlay :drop-target-column])]
            (when (not= target-index previous-target)
              (set-target-col target-index))))))))

(defn render-list
  [{:keys [group items column-index column-width
           card-renderer hide-scrollbars? local-state]}
   custom-props]
  (let [items (or (:items custom-props) items)
        cache (js/ReactVirtualized.CellMeasurerCache.
               #js
                {:defaultHeight 150
                 :fixed-width   true
                 :fixedWidth    true})
        droppable-id (str "droppable-group-" group)
        scroll-top (get-in @local-state [:kanban :column-scroll-top column-index])]
    (r/create-class
     {:display-name           "rendered-list"
      :component-did-mount    (fn []
                                  ;Todo scroll to previous scroll position here
                                )

      :component-will-unmount (fn [])
      :reagent-render
      (fn []
        (r/as-element
         [droppable
          {:droppable-id droppable-id
           :mode         "virtual"
           :type         "COLUMN"
           :is-drop-disabled true
           :render-clone (fn [provided snapshot rubric]
                           (calculate-drop-position local-state)

                           (let [item-index (.-index (.-source rubric))
                                 props (js->clj (.-draggableProps provided))
                                 draggable-props (assoc-in props ["style" "opacity"] 1)
                                 item (nth items item-index)]

                             (r/as-element
                              ^{:key (str "field-item-key-"
                                          (-> item
                                              :key
                                              str))}
                              [:div
                               (merge
                                {:id "drag-clone"}
                                draggable-props
                                (js->clj (.-dragHandleProps provided))
                                {:ref (.-innerRef provided)})
                               (card-renderer {:data item})])))}
          (fn
            [droppableProvided snapshot]
            (r/as-element
             [:> js/ReactVirtualized.AutoSizer
              (fn [m]
                (let [autosizer-height (aget m "height")
                      item-count (if (.-isDragging snapshot)
                                   (+ 1 (count items))
                                   (count items))]
                  (r/as-element
                   (into
                    [:> js/ReactVirtualized.List
                     (merge {:row-count          item-count
                             :width              column-width
                             :height             autosizer-height
                             :row-height         (.-rowHeight cache)
                             :on-scroll          (fn [e]
                                                   (let [scroll-event (js->clj e :keywordize-keys true)
                                                         scroll-top (:scrollTop scroll-event)]
                                                     (swap! local-state assoc-in
                                                            [:kanban :column-scroll-top column-index]
                                                            scroll-top)
                                                     ;Todo handle here saving scroll state for later
                                                     ))
                             :overscan-row-count 3
                             :row-renderer       (partial row-renderer
                                                          {:items         items
                                                           :cache         cache
                                                           :outer-column-index column-index
                                                           :droppable-id  droppable-id
                                                           :droppable-provided droppableProvided
                                                           :item-count    item-count
                                                           :card-renderer card-renderer})
                             :ref                (fn [ref]
                                                   (when ref
                                                     (let [grid (aget ref "Grid")
                                                           container (aget grid "_scrollingContainer")]
                                                       (.innerRef droppableProvided container)

                                                       #_(let [scroll-to-pos-fn (aget ref "scrollToPosition")]
                                                           (.call scroll-to-pos-fn ref scroll-top))
                                                       (swap! local-state assoc-in [:kanban :board-list-ref] ref))))})]))))]))]))})))

(defn drop-target-indicator
  []
  [:div
   {:style {:margin-top      "20px"
            :height          "150px"
            :border-radius   "10px"
            :border          "3px solid blue"
            :background      "#def5ff"
            :display         "flex"
            :justify-content "center"
            :align-items     "center"}}
   "Move here"])

(defn default-column-renderer
  [own-props default-props]
  (let [{:keys [data config]} own-props
        {:keys [column-index render-list board-height is-drop-target? local-state]} default-props
        background-color (if (= (mod column-index 2) 0) "white" "#f5f5f5")
        column-label (-> data
                         :column-labels
                         (nth column-index))

        ; optional

        column-groups (or (-> data
                              :column-groups)
                          [])

        summary-footer-settings (-> config
                                    :view-settings
                                    :summary-footer)

        show-summary-footer? (:show-summary? summary-footer-settings)
        summary-footer-content (:content summary-footer-settings)

        column-item-count (some-> data
                                  :column-contents
                                  (nth column-index)
                                  (count))

        footer-content-strings (->> summary-footer-content
                                    (mapv (fn [kw]
                                            (condp = kw

                                              :total-count
                                              (let [total-count (-> data
                                                                    :column-contents
                                                                    (nth column-index)
                                                                    (count))]
                                                (str "Total count: " total-count))
                                              ; Todo create more cases
                                              ""))))]
    [:div
     {:style {:height         board-height
              :display        "flex"
              :flex-direction "column"
              :background     "#f5f5f5"
              ;:border         "1px solid #cccccc"
              }}
     [:div.d-flex.p-3.justify-content-between
      {:style {:background "white"
               ;:border-bottom "1px solid #cccccc"
               :border     "1px solid #cccccc"}}
      [:div
       {:style {:font-size     "21px"
                :font-weight   "thin"
                :text-overflow "ellipsis"
                :overflow      "hidden"
                :white-space   "nowrap"}}
       (str column-label)]
      [:div
       {:style {:font-size   "21px"
                :font-weight "thin"
                :margin-left "20px"}}
       column-item-count]]
     [:div.hide-scrollbars.column-group-scroller
      {:style     {:flex-grow  "1"
                   :background (if is-drop-target? "#fafafa" "#f2f2ee")
                   :overflow   "scroll"}
       :on-scroll (fn [e]
                    (let [el (.-currentTarget e)
                          scroll-top (.-scrollTop el)
                          all-scrollers (vec
                                         (array-seq
                                          (.getElementsByClassName js/document "column-group-scroller")))]
                      (->> all-scrollers
                           (map (fn [scroller]
                                  (when-not (= scroller el)
                                    (.scroll scroller 0 scroll-top))))
                           (doall)))
                    #_(let [column-group-headers (.getElementsByClassName js/document "column-group-header")
                            first-cells
                            (->>
                             column-groups
                             (map-indexed
                              (fn [group-index group]
                                (let [headers (vec
                                               (array-seq
                                                (.getElementsByClassName js/document
                                                                         (str "column-group-" group-index "-header"))))]
                                  (when-let [first-cell (first headers)]
                                    (let [rect (.getBoundingClientRect first-cell)
                                          top (.-top rect)]
                                      (swap! local-state assoc-in [:group-title-tops group-index] top))))))
                             (doall))]))}
      #_(when is-drop-target? [drop-target-indicator])

      ; Test
      (->> column-groups
           (map-indexed (fn [group-index group]
                          (let [expanded? (when local-state
                                            (get-in @local-state [:expand-group group-index]))
                                items (or (some-> data
                                                  :column-group-contents
                                                  (nth column-index)
                                                  (nth group-index))
                                          [])
                                group-items-count (some->> data
                                                           :column-group-contents
                                                           (mapv (fn [col]
                                                                   (nth col group-index)))
                                                           (mapv count)
                                                           (reduce +))]
                            ^{:key (str "grouping-" group-index)}
                            [:div
                             {:class (fu/cs "cursor-pointer")
                              :style {:height        (if expanded? (- board-height 60) "70px")
                                      :position      "sticky"
                                      :top           0
                                      :overflow      "hidden"
                                      :border-bottom "1px solid #cccccc"}}
                             [:div.d-flex.flex-column.justify-content-center
                              {:class    (fu/cs (str "column-group-" group-index "-header"))
                               :style    {:min-height "70px" :background "white"}
                               :on-click (fn []
                                           (swap! local-state assoc-in [:expand-group group-index] (not expanded?))
                                           (re-render-kanban-board local-state))}
                              (when (= column-index 0)
                                [:div.d-flex.ml-4.align-items-center
                                 [:i.fas.fa-angle-down.mr-3
                                  {:style {:transform (if expanded? "" "rotate(-90deg)")}}]
                                 [:p group]
                                 [:p.ml-3
                                  {:style {:font-size "13px"}}
                                  (str "" group-items-count " items")]])]
                             (when expanded?
                               [:div
                                {:style {:border     "1px solid #cccccc"
                                         :background "#f2f2ee"
                                         :height     (- board-height 130)}}
                                (when render-list [render-list {:items items}])])])))
           (doall))

      #_[:div
         {:style {:border "1px solid #cccccc"
                  :height "100%"}}
         (when render-list [render-list])]]

     (when show-summary-footer?
       [:div
        {:style {:min-height "50px"
                 :background "white"
                 :border-top "1px solid #cccccc"
                 :padding    "10px"}}
        (->> footer-content-strings
             (map (fn [str-val]
                    ^{:key str-val}
                    [:p
                     {:style {:font-weight "600"}}
                     str-val])))])]))

(defn kanban-cell-renderer
  [props js-args]
  (let [{:keys [data column-renderer board-height column-width
                card-renderer column-gap local-state]}
        props
        {:keys [style columnIndex]} (js->clj js-args :keywordize-keys true)
        items (-> data
                  :column-contents
                  (nth columnIndex))]
    (r/as-element
     ^{:key (str "kanban-column-" columnIndex)}
     [:div
      {:style      (merge style
                          {:padding-right (str column-gap "px")})
       :class-name "hello"}
      [column-renderer
       {:column-index columnIndex
        :board-height board-height
        :local-state  local-state
        :render-list  (partial render-list
                               {:group            columnIndex
                                :local-state      local-state
                                :items            items
                                :column-width     column-width
                                :column-index     columnIndex
                                :card-renderer    card-renderer
                                :hide-scrollbars? (:isScrolling js-args)})}]])))


; Explanation for the functions below:
; When user starts dragging a card from the very edge of the board,
; normally, the kanban board starts auto scrolling.
; This causes the kanban columns to re-render,
; which causes beautiful-dnd to lose reference to drop area and
; that leads to an error. Now, we prevent the board from scrolling
; when mouse is pressed down, indicating that user starts dragging.
; After the onDragStart event has fired or when mouse is lifted up,
; we can allow scrolling again.
(defn prevent-kanban-scroll
  []
  (when-let [kanban-el (.getElementById js/document "kanban-board")]
    (.add (.-classList kanban-el) "kanban-prevent-scroll")))
(defn allow-kanban-scroll
  []
  (when-let [kanban-el (.getElementById js/document "kanban-board")]
    (.remove (.-classList kanban-el) "kanban-prevent-scroll")))

(defn kanban-board
  [{:keys [board-height column-width column-gap board-width column-count local-state] :as args}]
  (let [on-scroll (fn [e]
                    (let [clj-event (js->clj e :keywordize-keys true)
                          scroll-left (:scrollLeft clj-event)]
                      (swap! local-state assoc-in [:kanban :scroll-left] scroll-left)))]

    (.addEventListener js/document "mousedown" prevent-kanban-scroll)
    (.addEventListener js/document "mouseup" allow-kanban-scroll)

    (r/as-element
     [:> js/ReactVirtualized.Grid
      {:height        board-height
       :column-count  column-count
       :column-width  (if column-gap
                        (+ column-width column-gap)
                        column-width)
       :id            "kanban-board"
       :row-count     1
       :row-height    board-height
       :width         board-width
       :style         {:position "absolute" :z-index "2"}
       :overscan-column-count 4
       :on-scroll     on-scroll
       ;:is-scrolling-opt-out  true
       :ref           (fn [ref]
                        (swap! local-state assoc-in [:kanban :board-ref] ref))
       :cell-renderer (partial kanban-cell-renderer args)}])))

(defn new-kanban-row-renderer
  [{:keys [column-width board-width row-contents local-state row-index]}]
  (let [max-height (->> row-contents
                        (map count)
                        (apply max)
                        (* 250)
                        (+ 70)
                        (+ 50))
        main-list-scroll-top (:main-list-scroll-top @local-state)
        row-start (* row-index 70)
        is-at-top? (<= row-start main-list-scroll-top)]
    (r/as-element
     [:> js/ReactVirtualized.Grid
      {:height        max-height
       :column-count  (count row-contents)
       :column-width  column-width
       :id            (str "kanban-board-" row-index)
       :row-count     1
       :row-height    max-height
       :width         board-width
       :overscan-column-count 4
       ;:style                 {:overflow-y (if is-at-top? "scroll" "hidden")}
       ;:is-scrolling-opt-out  true
       :on-scroll     (fn [e]
                        (let [clj-event (js->clj e :keywordize-keys true)
                              scroll-left (:scrollLeft clj-event)]
                          (when-let [header-container (.getElementById js/document "kanban-header-container")]
                            (.scroll header-container scroll-left 0))
                          (let [row-indices (->> (get-in @local-state [:row-scroller-ref])
                                                 (keys)
                                                 (vec))]
                            (->> row-indices
                                 (map (fn [index]
                                        (when (not= index row-index)
                                          (when-let [row-node (get-in @local-state [:row-scroller-node index])]
                                            (.scroll row-node scroll-left 0)))))
                                 (doall)))))
       :ref           (fn [ref]
                        (when ref
                          (swap! local-state assoc-in [:row-scroller-ref row-index] ref)
                          (when-let [container (aget ref "_scrollingContainer")]
                            (swap! local-state assoc-in [:row-scroller-node row-index] container))))

       :cell-renderer (fn [props]
                        (let [{:keys [style index columnIndex]} (js->clj props :keywordize-keys true)]
                          (let [column-items (nth row-contents columnIndex)]
                            (r/as-element
                             [:div
                              {:style (merge style {:padding-left "20px"})}
                              (->> column-items
                                   (map (fn [item]
                                          ^{:key (:db/id item)}
                                          [:div.p-2
                                           [kanban-card
                                            {:data         item
                                             :column-index columnIndex}
                                            {:look-and-feel {:card-size :medium}}]]))
                                   (doall))]))))}])))

(defn new-kanban-headers
  [{:keys [board-height data column-count
           column-width column-gap
           board-width column-renderer
           card-renderer local-state]}]
  [:div.d-flex.hide-scrollbars
   {:style {:overflow "hidden" :overflow-x "auto"}
    :id    "kanban-header-container"}
   (->> data
        :column-labels
        (map-indexed (fn [index label]
                       ^{:key (str "group-heading-" index)}
                       [:div.p-3
                        {:style {:min-width column-width
                                 :height    "70px"
                                 :border    "1px solid #cccccc"
                                 :font-size "22px"}}
                        label])))])


(defn new-kanban-board
  [{:keys [board-height data column-count
           column-width column-gap
           board-width column-renderer
           card-renderer local-state]}]
  (let [row-count (->> data
                       :column-groups
                       count)
        contents (-> data
                     :contents)]
    [:div
     {:style {:position "absolute" :z-index "2" :width "100%" :overflow "hidden"}}

     [new-kanban-headers
      {:data         data
       :column-width column-width
       :local-state  local-state}]

     (let [main-scroll-top (:main-list-scroll-top @local-state)
           main-list-top (when-let [main-list (.getElementById js/document "main-list")]
                           (let [rect (.getBoundingClientRect main-list)
                                 top (.-top rect)]
                             top))

           groups (array-seq (.getElementsByClassName js/document "main-list-group"))

           top-group-index (some->> groups
                                    (filter (fn [el]
                                              (let [rect (.getBoundingClientRect el)
                                                    top (.-top rect)]
                                                (<= top main-list-top))))
                                    (last))

           top-group-index (if top-group-index
                             (-> top-group-index
                                 (.-id)
                                 (int))
                             0)

           first-visible-group (some->> groups
                                        (filter (fn [el]
                                                  (let [rect (.getBoundingClientRect el)
                                                        top (.-top rect)]
                                                    (not (<= top main-list-top)))))
                                        (first))

           visible-group-top (if first-visible-group
                               (when-let [rect (.getBoundingClientRect first-visible-group)]
                                 (.-top rect))
                               10000)

           difference (- visible-group-top main-list-top 70)

           top (min 0 difference)


           group (-> data
                     :column-groups
                     (nth top-group-index))

           expanded? (get-in @local-state [:expand-group top-group-index])]
       (when expanded?
         [:div
          {:style {:position "absolute"
                   :z-index  "5"
                   :overflow "hidden"
                   :width    "100%"
                   :height   "70px"}}
          [:div.d-flex.flex-column.justify-content-center
           {:class    (fu/cs "cursor-pointer")
            :style    {:height        "70px"
                       :background    "white"
                       :position      "absolute"
                       :top           (str top "px")
                       :bottom        "0px"
                       :left          "0px"
                       :right         "0px"
                       :border-bottom "1px solid #cccccc"}
            :on-click (fn []
                        (swap! local-state assoc-in [:expand-group top-group-index] (not expanded?))
                        (js/setTimeout (fn []
                                         (when-let [board-ref (get-in @local-state [:new-kanban :outer-list-ref])]
                                           (when-let [recompute-fn (aget board-ref "recomputeRowHeights")]
                                             (.call recompute-fn board-ref))))
                                       50))}
           [:div.d-flex.ml-4.align-items-center
            [:i.fas.fa-angle-down.mr-3
             {:style {:transform (if expanded? "" "rotate(-90deg)")}}]
            [:p group]
            [:p.ml-3
             {:style {:font-size "13px"}}]]]]))
     (r/as-element
      (into
       [:> js/ReactVirtualized.List
        (merge
         {:row-count    row-count
          :id           "main-list"
          :width        board-width
          :height       board-height
          :row-height   (fn [props]
                          (let [{:keys [index]} (js->clj props :keywordize-keys true)
                                expanded? (get-in @local-state [:expand-group index])
                                row-contents (nth contents index)

                                ; Todo calculate this based on contents
                                row-height (if expanded?
                                             (->> row-contents
                                                  (map count)
                                                  (apply max)
                                                  (* 250)
                                                  (+ 70))
                                             70)]
                            row-height))
          :overscan-row-count 3
          :on-scroll    (fn [args]
                          (let [{:keys [scrollTop]} (js->clj args :keywordize-keys true)]
                            (swap! local-state assoc :main-list-scroll-top scrollTop)))
          :row-renderer (fn [props]
                          (let [{:keys [style columnIndex index]} (js->clj props :keywordize-keys true)
                                group-index index
                                column-index columnIndex
                                expanded? (get-in @local-state [:expand-group group-index])
                                group (-> data
                                          :column-groups
                                          (nth group-index))

                                row-contents (nth contents group-index)

                                main-list-scroll-top (:main-list-scroll-top @local-state)
                                row-start (* group-index 70)
                                is-at-top? (<= row-start main-list-scroll-top)

                                ; Todo calculate this based on contents
                                row-height (if expanded?
                                             (->> row-contents
                                                  (map count)
                                                  (apply max)
                                                  (* 250)
                                                  (+ 70))
                                             "70px")]
                            (r/as-element
                             [:div.main-list-group
                              {:style (merge
                                       style
                                       {:height        row-height
                                        :overflow      "hidden"
                                        :border-bottom "1px solid #cccccc"})
                               :id    (str group-index)}
                              [:div.d-flex.flex-column.justify-content-center
                               {:class    (fu/cs (str "column-group-" group-index "-header") "cursor-pointer")
                                :style    {:min-height "70px"
                                           :background "white"}
                                :on-click (fn []
                                            (swap! local-state assoc-in [:expand-group group-index] (not expanded?))
                                            (js/setTimeout
                                             (fn []
                                               (when-let [board-ref (get-in @local-state [:new-kanban :outer-list-ref])]
                                                 (when-let [recompute-fn (aget board-ref "recomputeRowHeights")]
                                                   (.call recompute-fn board-ref))))
                                             50))}
                               [:div.d-flex.ml-4.align-items-center
                                [:i.fas.fa-angle-down.mr-3
                                 {:style {:transform (if expanded? "" "rotate(-90deg)")}}]
                                [:p group]
                                [:p.ml-3
                                 {:style {:font-size "13px"}}]]]
                              (when expanded?
                                [:div
                                 {:style {:border     "1px solid #cccccc"
                                          :background "#f2f2ee"}}
                                 (new-kanban-row-renderer
                                  {:local-state  local-state
                                   :column-width column-width
                                   :board-width  board-width
                                   :row-contents row-contents
                                   :row-index    group-index})])])))
          :ref          (fn [ref]
                          (when ref
                            (swap! local-state assoc-in [:new-kanban :outer-list-ref] ref)))})]))]))


(defn overlay-column-renderer
  [props js-args]
  (let [{:keys [column-renderer column-gap board-height local-state]} props
        {:keys [style columnIndex]} (js->clj js-args :keywordize-keys true)
        drop-target-column (get-in @local-state [:overlay :drop-target-column])
        is-drop-target? (= columnIndex drop-target-column)]
    (r/as-element
     ^{:key (str "overlay-column-" columnIndex)}
     [:div {:style (merge style {:padding-right (str column-gap "px")})}
      [column-renderer
       {:column-index    columnIndex
        :board-height    board-height
        :local-state     local-state
        :is-drop-target? is-drop-target?}]])))

(defn overlay-draggable-renderer
  [props js-args]
  (let [{:keys [board-height column-width local-state]} props
        {:keys [style columnIndex]} (js->clj js-args :keywordize-keys true)
        kanban-id (get-in @local-state [:kanban :id])]
    (r/as-element
     [:div {:style style :key (str "overlay-draggable-item-" columnIndex)}
      (r/as-element
       [draggable
        {:key          (str "overlay-" columnIndex)
         :draggable-id (str "overlay-" columnIndex)
         :index        columnIndex}
        (fn
          [provided snapshot]
          (r/as-element
           [:div
            (merge
             {:class-name (str "drop-target" " " "drop-target-" columnIndex " " "kanban-" kanban-id "-drop-target")
              :style      {:overflow     "visible"
                           :display      "hidden"
                           ;:border       "1px solid blue"
                           :margin-right "-20px"
                           :height       board-height
                           :width        column-width}}
             (js->clj (.-draggableProps provided))
             (js->clj (.-dragHandleProps provided))
             {:ref (.-innerRef provided)})
            [:div.d-flex.flex-column
             {:style {:height "100%"}}]]))])])))

(defn overlay-board
  [{:keys [column-renderer board-height board-width local-state
           column-count column-width column-gap background-color]}]
  (let [on-scroll-droppable (fn [e]
                              (let [event (js->clj e :keywordize-keys true)
                                    droppable-scroll-left (:scrollLeft event)]
                                (if-let [overlay-grid-node (get-in @local-state [:overlay :board-node])]
                                  (.scroll overlay-grid-node droppable-scroll-left 0)
                                  (js/console.warn "overlay sync failed"))))
        is-dragging? (r/cursor local-state [:kanban :is-dragging?])]
    (r/as-element
     [:div
      {:style {:width      board-width
               :height     board-height
               :position   "absolute"
               :overflow   "visible"
               :background background-color
               :z-index    (if @is-dragging? "5" "-1")}}
      (r/as-element
       [:> js/ReactVirtualized.Grid
        {:height        board-height
         :column-count  column-count
         :column-width  (if column-gap
                          (+ column-width column-gap)
                          column-width)
         :row-count     1
         :style         {:position "absolute"}
         :row-height    board-height
         :width         board-width
         :overscan-column-count 3
         :cell-renderer (partial overlay-column-renderer
                                 {:board-height    board-height
                                  :column-renderer column-renderer
                                  :column-gap      column-gap
                                  :column-width    column-width
                                  :local-state     local-state})
         :ref           (fn [ref]
                          (when ref
                            (let [container (aget ref "_scrollingContainer")]
                              (swap! local-state assoc-in [:overlay :board-node] container)
                              (swap! local-state assoc-in [:overlay :board-ref] ref))))}])
      (r/as-element
       [droppable
        {:droppable-id "overlay-droppable"
         :type         "COLUMN"
         :direction    "horizontal"
         :mode         "virtual"
         :render-clone (fn [provided snapshot rubric]
                         (let [item-index (.-index (.-source rubric))
                               snap-clj (js->clj snapshot :keywordize-keys true)]
                           (r/as-element
                            ^{:key (str "clone-item-key-" item-index)}
                            [:div
                             (merge
                              (js->clj (.-draggableProps provided))
                              (js->clj (.-dragHandleProps provided))
                              {:ref (.-innerRef provided)})
                             [:div "HELLO WORLD"]])))
         :key          1}
        (fn
          [droppableProvided snapshot]
          (r/as-element
           [:> js/ReactVirtualized.Grid
            {:height        (- board-height 52)
             :column-count  column-count
             :column-width  (if column-gap
                              (+ column-width column-gap)
                              column-width)
             :row-count     1
             :style         {:position "absolute" :top 55} ; Todo top needs to be dynamic depending on column header height
             :row-height    (- board-height 55)
             :class-name    "hide-scrollbars"
             :width         board-width
             :on-scroll     on-scroll-droppable
             :overscan-column-count 1
             :cell-renderer (partial overlay-draggable-renderer
                                     {:board-height (- board-height 100)
                                      :column-width column-width
                                      :local-state  local-state})

             :ref           (fn [ref]
                              (when ref
                                (let [container (aget ref "_scrollingContainer")]
                                  (. droppableProvided innerRef container)
                                  (swap! local-state assoc-in [:overlay :droppable-node] container))))}]))])])))

(defn view
  "
  props:

  data {:column-values []
        :column-labels []
        :column-contents [[]]
        }
  "
  [{:keys [kanban-id card-renderer board-height board-width
           column-width column-gap column-count column-renderer
           background-color on-drag-end data]}]
  (let [local-state (r/atom {:kanban           {:is-dragging? false
                                                :scroll-left  0
                                                :id           kanban-id
                                                :board-ref    nil
                                                ; other stuff goes here also
                                                }
                             :overlay          {:droppable-node     nil
                                                :board-node         nil
                                                :board-ref          nil
                                                :drop-target-column nil}
                             :expand-group     {0 false}
                             :group-title-tops {}})

        scroll-overlay-to (fn [left]
                            (when-let [overlay-droppable-node (get-in @local-state [:overlay :droppable-node])]
                              (.scroll overlay-droppable-node left 0)))
        handle-drag-start (fn [e]
                            (allow-kanban-scroll)
                            (let [event (js->clj e :keywordize-keys true)
                                  {:keys [draggableId source]} event
                                  board-ref (get-in @local-state [:kanban :board-ref])
                                  board-node (aget board-ref "_scrollingContainer")
                                  board-scroll-left (.-scrollLeft board-node)]
                              (scroll-overlay-to board-scroll-left)
                              (swap! local-state assoc-in [:kanban :is-dragging?] true)))

        handle-drag-end (fn [e]
                          (let [event (js->clj e :keywordize-keys true)
                                draggable-id (:draggableId event)]
                            (if (string/starts-with? (str draggable-id) "overlay")
                              (js/console.log "Dragged overlay item")

                              ; Scroll original board to overlay position
                              (let [overlay-board-node (get-in @local-state [:overlay :board-node])
                                    overlay-scroll-left (.-scrollLeft overlay-board-node)
                                    kanban-grid-ref (get-in @local-state [:kanban :board-ref])
                                    grid-node (aget kanban-grid-ref "_scrollingContainer")]

                                (.scroll grid-node overlay-scroll-left 0)

                                (swap! local-state assoc-in [:overlay :drop-target-column] nil)

                                (let [clj-event (js->clj e)
                                      source-group (-> (get (get clj-event "source") "droppableId")
                                                       (string/split #"-")
                                                       (nth 2)
                                                       (int))

                                      draggable-id (js/parseInt (get clj-event "draggableId"))

                                      destination (get (get clj-event "destination") "index")

                                      target-column-id (when (< destination column-count)
                                                         (-> data
                                                             :column-values
                                                             (nth destination)))
                                      recompute-fn (aget kanban-grid-ref "recomputeGridSize")]
                                  (when (and destination (< destination column-count))
                                    (on-drag-end {:item-id          draggable-id
                                                  :source-col-index source-group
                                                  :target-col-index destination
                                                  :target-col-id    target-column-id}))

                                  (js/setTimeout
                                   (fn []
                                     (.call recompute-fn kanban-grid-ref)
                                     (swap! local-state assoc-in [:kanban :is-dragging?] false))
                                   10))))))]
    [drag-drop-context
     {:onDragStart handle-drag-start
      :onDragEnd   handle-drag-end}
     [:div
      {:class "flex flex-col px-4"
       :style {:position "relative"
               :overflow "hidden"
               :width    board-width
               :height   board-height}}

      [overlay-board
       {:data             data
        :column-renderer  column-renderer
        :board-width      board-width
        :column-width     column-width
        :column-gap       column-gap
        :board-height     board-height
        :column-count     column-count
        :background-color background-color
        :local-state      local-state}]
      [:div
       {:style {:width      "100%"
                :height     "100%"
                :position   "absolute"
                :z-index    "1"
                :background background-color}}]
      [new-kanban-board
       {:board-height    board-height
        :data            data
        :column-count    column-count
        :column-width    column-width
        :column-gap      column-gap
        :board-width     board-width
        :column-renderer column-renderer
        :card-renderer   card-renderer
        :local-state     local-state}]]]))
